import {
  PromotionCodeColumn,
  PromotionCodeConfigurationEditMutation,
  PromotionCodeFetchResult,
} from '../types';

const statusOnChange = async (
  item: PromotionCodeColumn | undefined,
  editMutation: PromotionCodeConfigurationEditMutation
): Promise<PromotionCodeFetchResult> => {
  const id = item?.actions.id || '';
  const toEdit = {
    id,
    status: !item?.status,
  };
  const edited = await editMutation({
    variables: { input: toEdit },
  });
  return edited;
};

export default statusOnChange;
